import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { VoteInfoParams } from '@module/apis/client-side/vote/type';

export const voteQueryKeys = createQueryKeys('vote', {
  addVote: () => ['addVote'],
  editVote: () => ['editVote'],
  attendVote: () => ['attendVote'],
  endVote: () => ['endVote'],
  deleteVote: () => ['deleteVote'],
  topFixedVote: () => ['topFixedVote'], // 투표 상단 고정
  fetchVoteInfo: (voteInfoParams: VoteInfoParams) => [voteInfoParams],
});
